// Copied from https://gist.github.com/ryanflorence/10e9387f633f9d2e6f444a9bddaabf6e
import { useState } from 'react';
export default function useDescendants() {
  return useState([]);
}